/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ScheduleProjectFragmentDoc, SchedulePlanSessionFragmentDoc, ScheduleWhoFragmentDoc } from './Fragments.generated.js';
import { OrganisationMemberListItem__OrganisationMembershipFragmentDoc } from '../organisations/OrganisationMember.generated.js';
import { LastModifiedInfoBoxFragmentDoc } from '../documents/LastModifiedInfo.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ScheduleQuery = { projectsAsContractor: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, planSessions: Array<{ __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } }>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } }> } };

export type ScheduleResourcesQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit: Types.Scalars['Int']['input'];
}>;


export type ScheduleResourcesQuery = { organisationMemberships: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationMembershipsConnection', totalCount: number, edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, organisationId: string, organisationTitle: string, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, locale: string, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> } }> } };

export type ScheduleModifyPlanSessionMutationVariables = Types.Exact<{
  planSession: Types.ModifyPlanSessionInput;
}>;


export type ScheduleModifyPlanSessionMutation = { modifyPlanSession: { __typename: 'ModifyPlanSessionResult', planSession: { __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } }, project: { __typename: 'Project', id: string, lastModified?: { __typename: 'LastModifiedInfo', at: any, by?: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, url: string } | null } | null } | null } } };


export const ScheduleDocument = gql`
    query Schedule {
  projectsAsContractor: projects(limit: 0, filters: {kind: DEFAULT}) {
    ... on ProjectConnection {
      edges {
        node {
          id
          ...ScheduleProject
          planSessions {
            id
            ...SchedulePlanSession
          }
        }
      }
    }
  }
}
    ${ScheduleProjectFragmentDoc}
${SchedulePlanSessionFragmentDoc}`;

/**
 * __useScheduleQuery__
 *
 * To run a query within a React component, call `useScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
      }
export function useScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
        }
export function useScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleQuery, ScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleQuery, ScheduleQueryVariables>(ScheduleDocument, options);
        }
export type ScheduleQueryHookResult = ReturnType<typeof useScheduleQuery>;
export type ScheduleLazyQueryHookResult = ReturnType<typeof useScheduleLazyQuery>;
export type ScheduleSuspenseQueryHookResult = ReturnType<typeof useScheduleSuspenseQuery>;
export type ScheduleQueryResult = Apollo.QueryResult<ScheduleQuery, ScheduleQueryVariables>;
export const ScheduleResourcesDocument = gql`
    query ScheduleResources($offset: Int, $limit: Int!) {
  organisationMemberships(
    offset: $offset
    limit: $limit
    sorting: [{column: firstname, direction: asc}]
    filters: {statuses: [ACTIVATED]}
  ) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          ...ScheduleWho
          roles {
            id
            label
          }
          ...OrganisationMemberListItem__OrganisationMembership
        }
      }
      totalCount
    }
  }
}
    ${ScheduleWhoFragmentDoc}
${OrganisationMemberListItem__OrganisationMembershipFragmentDoc}`;

/**
 * __useScheduleResourcesQuery__
 *
 * To run a query within a React component, call `useScheduleResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleResourcesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useScheduleResourcesQuery(baseOptions: Apollo.QueryHookOptions<ScheduleResourcesQuery, ScheduleResourcesQueryVariables> & ({ variables: ScheduleResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>(ScheduleResourcesDocument, options);
      }
export function useScheduleResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>(ScheduleResourcesDocument, options);
        }
export function useScheduleResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>(ScheduleResourcesDocument, options);
        }
export type ScheduleResourcesQueryHookResult = ReturnType<typeof useScheduleResourcesQuery>;
export type ScheduleResourcesLazyQueryHookResult = ReturnType<typeof useScheduleResourcesLazyQuery>;
export type ScheduleResourcesSuspenseQueryHookResult = ReturnType<typeof useScheduleResourcesSuspenseQuery>;
export type ScheduleResourcesQueryResult = Apollo.QueryResult<ScheduleResourcesQuery, ScheduleResourcesQueryVariables>;
export const ScheduleModifyPlanSessionDocument = gql`
    mutation ScheduleModifyPlanSession($planSession: ModifyPlanSessionInput!) {
  modifyPlanSession(input: $planSession) {
    planSession {
      id
      ...SchedulePlanSession
    }
    project {
      id
      lastModified {
        ...LastModifiedInfoBox
      }
    }
  }
}
    ${SchedulePlanSessionFragmentDoc}
${LastModifiedInfoBoxFragmentDoc}`;
export type ScheduleModifyPlanSessionMutationFn = Apollo.MutationFunction<ScheduleModifyPlanSessionMutation, ScheduleModifyPlanSessionMutationVariables>;

/**
 * __useScheduleModifyPlanSessionMutation__
 *
 * To run a mutation, you first call `useScheduleModifyPlanSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleModifyPlanSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleModifyPlanSessionMutation, { data, loading, error }] = useScheduleModifyPlanSessionMutation({
 *   variables: {
 *      planSession: // value for 'planSession'
 *   },
 * });
 */
export function useScheduleModifyPlanSessionMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleModifyPlanSessionMutation, ScheduleModifyPlanSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleModifyPlanSessionMutation, ScheduleModifyPlanSessionMutationVariables>(ScheduleModifyPlanSessionDocument, options);
      }
export type ScheduleModifyPlanSessionMutationHookResult = ReturnType<typeof useScheduleModifyPlanSessionMutation>;
export type ScheduleModifyPlanSessionMutationResult = Apollo.MutationResult<ScheduleModifyPlanSessionMutation>;
export type ScheduleModifyPlanSessionMutationOptions = Apollo.BaseMutationOptions<ScheduleModifyPlanSessionMutation, ScheduleModifyPlanSessionMutationVariables>;